module.exports = __webpack_public_path__ + "media/images/gateway/5-1b45008e7db3a8cd5c4075c16782f90a.png";